import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "modal-overlay position-fixed top-0 start-0 w-100 h-100 bg-opacity-50"
}
const _hoisted_3 = { class: "modal-dialog modal-xl w-100" }
const _hoisted_4 = {
  class: "modal-content bg-white table-mlo bg-white rounded-4",
  style: {"padding":"20px"}
}
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "d-flex gap-2 mb-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_10 = { class: "table-mlo w-100 bg-white rounded-4" }
const _hoisted_11 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("thead", { class: "" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Client Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Client Email"),
    /*#__PURE__*/_createElementVNode("th", null, "Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Actions")
  ])
], -1)
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border text-primary",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, "Loading economic sheets...")
], -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 2,
  class: "modal-body"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, "No economic sheets found")
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "modal-overlay position-fixed top-0 start-0 h-100 bg-dark bg-opacity-50"
}
const _hoisted_21 = { class: "modal-dialog modal-xl" }
const _hoisted_22 = {
  class: "modal-content bg-white table-mlo bg-white rounded-4",
  style: {"padding":"10px","overflow-y":"auto","max-height":"95vh"}
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"print-only-header\" style=\"display:none;\"><div class=\"text-center mb-4\"><h1 class=\"display-3 fw-bold text-dark mb-2\">PASIVE CASH DETAILS</h1><p class=\"fw-bold fs-4 text-secondary mb-4\">PROFIT OF ESTIMATED COST/BENEFITS</p><hr class=\"my-4\"></div></div>", 1)
const _hoisted_26 = {
  key: 0,
  class: "modal-body",
  id: "printable-content"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-4 print-title" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bold fs-5 mb-4" }, "PASIVE CASH"),
  /*#__PURE__*/_createElementVNode("p", { class: "fw-bold fs-5 mb-4" }, "PROFIT OF ESTIMATED COST/BENEFITS")
], -1)
const _hoisted_28 = {
  key: 0,
  class: "mb-4 print-section"
}
const _hoisted_29 = { class: "table-mlo w-100 bg-white rounded-4" }
const _hoisted_30 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "table-info" }, [
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      class: "text-center fw-bold fs-6 p-3"
    }, "CUSTOMER INFORMATION")
  ])
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", { class: "p-3 w-50" }, "NAME", -1)
const _hoisted_33 = { class: "p-3" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("td", { class: "p-3 w-50" }, "PHONE-NUMBER", -1)
const _hoisted_35 = { class: "p-3" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("td", { class: "p-3 w-50" }, "EMAIL", -1)
const _hoisted_37 = { class: "p-3" }
const _hoisted_38 = {
  key: 1,
  class: "mb-4 print-section"
}
const _hoisted_39 = { class: "table-mlo w-100 bg-white rounded-4" }
const _hoisted_40 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "table-info" }, [
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      class: "text-center fw-bold fs-6 p-3"
    }, "FINANCIAL INFORMATION")
  ])
], -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("td", { class: "p-3 w-50" }, "MONTHLY BUDGET PAYMENT", -1)
const _hoisted_43 = { class: "p-3" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("td", { class: "p-3 w-50" }, "PROPERTY ADRESSES", -1)
const _hoisted_45 = { class: "p-3" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("td", { class: "p-3 w-50" }, "PROPERTY PRICE", -1)
const _hoisted_47 = { class: "p-3" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("td", { class: "p-3 w-50" }, "PROPERTY TAXES ", -1)
const _hoisted_49 = { class: "p-3" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("td", { class: "p-3 w-50" }, "PROPERTY INSURANCE", -1)
const _hoisted_51 = { class: "p-3" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("td", { class: "p-3 w-50" }, "FEDERAL TAXES", -1)
const _hoisted_53 = { class: "p-3" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("td", { class: "p-3 w-50" }, "FLOOD INSURANCE", -1)
const _hoisted_55 = { class: "p-3" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("td", { class: "p-3 w-50" }, "ASSOCIACTION PAYMENT", -1)
const _hoisted_57 = { class: "p-3" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("td", { class: "p-3 w-50" }, "OTHERS MONTHLY PAYMENT ", -1)
const _hoisted_59 = { class: "p-3" }
const _hoisted_60 = { class: "" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("td", { class: "p-3 w-50" }, " MONTHLY PAYMENT", -1)
const _hoisted_62 = { class: "p-3" }
const _hoisted_63 = { class: "" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("td", { class: "p-3 w-50" }, "COMPANY FEES AND SERVICES", -1)
const _hoisted_65 = { class: "p-3" }
const _hoisted_66 = { class: "" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("td", { class: "p-3 w-50" }, "BROKER PAYMENT", -1)
const _hoisted_68 = { class: "p-3" }
const _hoisted_69 = { class: "" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("td", { class: "p-3 w-50" }, "ESTIMATE PROPERTY RENT", -1)
const _hoisted_71 = { class: "p-3" }
const _hoisted_72 = { class: "" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("td", { class: "p-3 w-50" }, "CAPITAL GAIN", -1)
const _hoisted_74 = { class: "p-3" }
const _hoisted_75 = { class: "" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("td", { class: "p-3 w-50" }, "TOTAL INVESTMENT", -1)
const _hoisted_77 = { class: "p-3" }
const _hoisted_78 = { class: "" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("td", { class: "p-3 w-50" }, "AVERAGE NET", -1)
const _hoisted_80 = { class: "p-3" }
const _hoisted_81 = {
  key: 2,
  class: "mb-4 print-section"
}
const _hoisted_82 = { class: "table-mlo w-100 bg-white rounded-4" }
const _hoisted_83 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "table-info" }, [
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      class: "text-center fw-bold fs-6 p-3"
    }, "MLO INFORMATION")
  ])
], -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("td", { class: "p-3 w-50" }, "NAME-MLO", -1)
const _hoisted_86 = { class: "p-3" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("td", { class: "p-3 w-50" }, "PHONE-NUMBER-MLO", -1)
const _hoisted_88 = { class: "p-3" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("td", { class: "p-3 w-50" }, "EMAIL-MLO", -1)
const _hoisted_90 = { class: "p-3" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("td", { class: "p-3 w-50" }, "INTEREST-RATE", -1)
const _hoisted_92 = { class: "p-3" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("td", { class: "p-3 w-50" }, "MINIMUM-DOWN-PAYMENT", -1)
const _hoisted_94 = { class: "p-3" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("td", { class: "p-3 w-50" }, "AVERAGE-PMI", -1)
const _hoisted_96 = { class: "p-3" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("td", { class: "p-3 w-50" }, "BACK-END-RATIO-DTI", -1)
const _hoisted_98 = { class: "p-3" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("td", { class: "p-3 w-50" }, "MAXIMUM-LOAN-NOT-JUMBO", -1)
const _hoisted_100 = { class: "p-3" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4 print-section" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "table-mlo w-100 bg-white rounded-4" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode("Note: The result of the investment that we show is an estimate that may mary,"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("depending on the variations that occur in the execution of the project.")
    ])
  ])
], -1)
const _hoisted_102 = {
  class: "print-footer",
  style: {"display":"none"}
}
const _hoisted_103 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_104 = { class: "text-center" }
const _hoisted_105 = { class: "text-muted" }
const _hoisted_106 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_107 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border text-primary",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, "Loading details...")
], -1)
const _hoisted_108 = [
  _hoisted_107
]

import { ref, onMounted, computed } from 'vue';
import TopBar from '@/components/admin/TopBar.vue';
import axios from 'axios';
import { environment } from "@/environment";
import UserService from "@/shared/services/user.service";

// Reactive state

export default /*#__PURE__*/_defineComponent({
  __name: 'SheetPasiveCash',
  setup(__props) {

const userSession = ref(null)
const showEconomicSheet = ref<boolean>(false)
const showDetailsModal = ref(false)
const loadingEconomicSheet = ref<boolean>(false)
const loadingDetails = ref(false)
const economicSheetData = ref([])
const customer = ref([])
const selectedMLO = ref([])
const customerSelected = ref([])
const comments = ref<string>('')

const url = environment.URL_API;

const getSession = () => {
  let session =
    localStorage.getItem("usersession") &&
      localStorage.getItem("usersession").length > 0
      ? JSON.parse(localStorage.getItem("usersession"))
      : null;

  if (session) {
    userSession.value = session;
  } else {
    UserService.logout("Session expired!");
  }
}
getSession();

const getEconomicSheet = async (): Promise<void> => {
  loadingEconomicSheet.value = true
  try {
    const scenario_type = "PASIVE CASH"
    const response = await axios(
      `${url}realtor-budget?user_id=${userSession.value.iduser}&scenario_type=${scenario_type}`,
      {
        method: "GET",
      }
    );
    if (!response.data.error) {
      customer.value = response.data.customer
    }
  } catch (error) {
    console.error('Error:', error)
  } finally {
    loadingEconomicSheet.value = false
  }
}

const getDetailsData = async (selectedCustomer: any): Promise<void> => {
  loadingDetails.value = true
  try {
    const scenario_type = "PASIVE CASH"
    const clientName = selectedCustomer.name || '';
    const clientEmail = selectedCustomer.email || '';

    console.log('Fetching details for:', { 
      user_id: userSession.value.iduser, 
      client_name: clientName, 
      client_email: clientEmail 
    });

    const response = await axios.get(`${url}realtor-budget/get-budget-details?user_id=${userSession.value.iduser}&scenario_type=${scenario_type}&client_name=${encodeURIComponent(clientName)}&client_email=${encodeURIComponent(clientEmail)}`)

    if (!response.data.error) {
      economicSheetData.value = response.data.realtorBudget
      selectedMLO.value = response.data.mloSelected
      customerSelected.value = response.data.customer

      console.log('Selected MLO after assignment:', selectedMLO.value);
    } else {
      console.error('API returned error:', response.data.error);
    }
  } catch (error) {
    console.error('Error fetching details:', error)
  } finally {
    loadingDetails.value = false
  }
}

const showDetails = async (customer: any) => {
  console.log('Showing details for customer:', customer);
  showDetailsModal.value = true
  await getDetailsData(customer)
}

const closeDetails = (): void => {
  showDetailsModal.value = false;
  economicSheetData.value = [];
  selectedMLO.value = [];
  customerSelected.value = [];
  comments.value = '';
}

const printEconomicSheet = (): void => {
  window.print()
}

const printBudgetDetails = (): void => {
  document.getElementById("printable-template").innerHTML =
    document.getElementById("printable-content").innerHTML;
  window.print();
}

const printBudget = (): void => {
  printBudgetDetails()
}

const sendBudget = (): void => {
  console.log('Sending budget with comments:', comments.value)
  alert('Budget sent successfully!')
}

const saveBudget = (): void => {
  console.log('Saving budget with comments:', comments.value)
  alert('Budget saved successfully!')
}

const formatNumber = (number: number | string | undefined): string => {
  if (!number || number === 'N/A') return '0'
  const num = parseFloat(number.toString())
  return isNaN(num) ? '0' : num.toLocaleString()
}

const getMLOFullName = (): string => {
  if (!selectedMLO.value || selectedMLO.value.length === 0) return 'N/A'
  
  const mlo = selectedMLO.value[0]
  const firstName = mlo?.name || mlo?.first_name || ''
  const lastName = mlo?.lastname || mlo?.last_name || ''
  
  return `${firstName} ${lastName}`.trim() || 'N/A'
}

const getCurrentDate = (): string => {
  return new Date().toLocaleDateString()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => {showEconomicSheet.value = true; getEconomicSheet()}),
      class: "btn btn-primary mb-3"
    }, " RECORD "),
    (showEconomicSheet.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (showEconomicSheet.value = false)),
                    class: "btn-close custom-close-button",
                    "aria-label": "Close"
                  }, _hoisted_8)
                ])
              ]),
              (!loadingEconomicSheet.value && customer.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("table", _hoisted_11, [
                        _hoisted_12,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customer.value, (item) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: item.budget_id
                            }, [
                              _createElementVNode("td", null, _toDisplayString(item.name || 'N/A'), 1),
                              _createElementVNode("td", null, _toDisplayString(item.email || 'N/A'), 1),
                              _createElementVNode("td", null, _toDisplayString(item.createdDate), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (showDetails(item)),
                                  class: "btn btn-sm btn-success"
                                }, " View Details ", 8, _hoisted_13)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (loadingEconomicSheet.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
                : _createCommentVNode("", true),
              (!loadingEconomicSheet.value && customer.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (showDetailsModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", { class: "modal-header print-hide" }, [
                _createElementVNode("div", { class: "d-flex gap-2" }, [
                  _createElementVNode("button", {
                    onClick: closeDetails,
                    class: "btn-close custom-close-button",
                    "aria-label": "Close"
                  }, _hoisted_24)
                ])
              ]),
              _hoisted_25,
              (!loadingDetails.value && economicSheetData.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _hoisted_27,
                    (customerSelected.value && customerSelected.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("table", _hoisted_30, [
                              _hoisted_31,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customerSelected.value, (customerItem) => {
                                return (_openBlock(), _createElementBlock("tbody", {
                                  key: customerItem.budget_id
                                }, [
                                  _createElementVNode("tr", null, [
                                    _hoisted_32,
                                    _createElementVNode("td", _hoisted_33, _toDisplayString(customerItem.name || 'N/A'), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_34,
                                    _createElementVNode("td", _hoisted_35, _toDisplayString(customerItem.phone || 'N/A'), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_36,
                                    _createElementVNode("td", _hoisted_37, _toDisplayString(customerItem.email || 'N/A'), 1)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (economicSheetData.value && economicSheetData.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("table", _hoisted_40, [
                              _hoisted_41,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(economicSheetData.value, (economicSheet) => {
                                return (_openBlock(), _createElementBlock("tbody", {
                                  key: economicSheet.budget_id
                                }, [
                                  _createElementVNode("tr", null, [
                                    _hoisted_42,
                                    _createElementVNode("td", _hoisted_43, _toDisplayString(economicSheet.typeProperty) + "%", 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_44,
                                    _createElementVNode("td", _hoisted_45, "$" + _toDisplayString(formatNumber(economicSheet.propertyAddresses)), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_46,
                                    _createElementVNode("td", _hoisted_47, "$" + _toDisplayString(formatNumber(economicSheet.propertyPrice)), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_48,
                                    _createElementVNode("td", _hoisted_49, "$" + _toDisplayString(formatNumber(economicSheet.propertyTaxes)), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_50,
                                    _createElementVNode("td", _hoisted_51, "$" + _toDisplayString(formatNumber(economicSheet.propertyinsurance)), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_52,
                                    _createElementVNode("td", _hoisted_53, "$" + _toDisplayString(formatNumber(economicSheet.federalTax)), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_54,
                                    _createElementVNode("td", _hoisted_55, "$" + _toDisplayString(formatNumber(economicSheet.floodinsurance)), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_56,
                                    _createElementVNode("td", _hoisted_57, "$" + _toDisplayString(formatNumber(economicSheet.associationPayment)), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_58,
                                    _createElementVNode("td", _hoisted_59, "$" + _toDisplayString(formatNumber(economicSheet.othersMonthlyPayment)), 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_60, [
                                    _hoisted_61,
                                    _createElementVNode("td", _hoisted_62, "$" + _toDisplayString(formatNumber(economicSheet.monthlyPayment)), 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_63, [
                                    _hoisted_64,
                                    _createElementVNode("td", _hoisted_65, "$" + _toDisplayString(formatNumber(economicSheet.companyFeesAndServices)), 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_66, [
                                    _hoisted_67,
                                    _createElementVNode("td", _hoisted_68, "$" + _toDisplayString(formatNumber(economicSheet.brokerPayment)), 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_69, [
                                    _hoisted_70,
                                    _createElementVNode("td", _hoisted_71, "$" + _toDisplayString(formatNumber(economicSheet.estimatePropertyRent)), 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_72, [
                                    _hoisted_73,
                                    _createElementVNode("td", _hoisted_74, "$" + _toDisplayString(formatNumber(economicSheet.capitalGain)), 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_75, [
                                    _hoisted_76,
                                    _createElementVNode("td", _hoisted_77, "$" + _toDisplayString(formatNumber(economicSheet.totalInvestment)), 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_78, [
                                    _hoisted_79,
                                    _createElementVNode("td", _hoisted_80, "$" + _toDisplayString(formatNumber(economicSheet.averageNet)), 1)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (selectedMLO.value && selectedMLO.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                          _createElementVNode("div", _hoisted_82, [
                            _createElementVNode("table", _hoisted_83, [
                              _hoisted_84,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedMLO.value, (mloItem) => {
                                return (_openBlock(), _createElementBlock("tbody", {
                                  key: mloItem.budget_id 
                                }, [
                                  _createElementVNode("tr", null, [
                                    _hoisted_85,
                                    _createElementVNode("td", _hoisted_86, _toDisplayString((mloItem.name|| '')  || 'N/A'), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_87,
                                    _createElementVNode("td", _hoisted_88, _toDisplayString(mloItem.phone || 'N/A'), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_89,
                                    _createElementVNode("td", _hoisted_90, _toDisplayString(mloItem.email || 'N/A'), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_91,
                                    _createElementVNode("td", _hoisted_92, _toDisplayString(mloItem.interestRate || 'N/A') + "%", 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_93,
                                    _createElementVNode("td", _hoisted_94, _toDisplayString(mloItem.minimumDownPayment  || 'N/A') + "%", 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_95,
                                    _createElementVNode("td", _hoisted_96, "$" + _toDisplayString(formatNumber(mloItem.pmi )), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_97,
                                    _createElementVNode("td", _hoisted_98, _toDisplayString(mloItem.backEndRatio || 'N/A') + "%", 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_99,
                                    _createElementVNode("td", _hoisted_100, "$" + _toDisplayString(formatNumber(mloItem.maximumLoanAmount )), 1)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_101,
                    _createElementVNode("div", _hoisted_102, [
                      _hoisted_103,
                      _createElementVNode("div", _hoisted_104, [
                        _createElementVNode("p", _hoisted_105, "Generated on " + _toDisplayString(getCurrentDate()), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (loadingDetails.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_106, _hoisted_108))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})